import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import './screen-emulator.css';

/** @class ScreenEmulator
  * A component for emulating different resolutions
  * and orientations of screens for considering
  * layouts among different devices.
  */
export default class ScreenEmulator extends Component {
  /** @constructor
    * Creates a new instance of ScreenEmulator
    */
  constructor(props) {
    super(props);
    this.state = {
      width: 1024,
      height: 768,
      scale: 1,
      rotate: false
    }
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRotate = this.handleRotate.bind(this);
    this.handleZoom = this.handleZoom.bind(this);
  }
  /** @method handleSelect
    * Event handler for evaulating option select events.
    */
  handleSelect(event) {
    var size = event.target.value.split('x');
    this.setState({width: size[0], height: size[1]});
  }
  /** @method handleChange
    * Event handler for input change events.
    */
  handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({[name]: value});
  }
  /** @method handleRotate
    * Event handler for rotating the screen resolution.
    */
  handleRotate() {
    this.setState({rotate: !this.state.rotate});
  }
  /** @method handleZoom
    * Event handler for zooming in or out on the emulated screen.
    */
  handleZoom(delta) {
    this.setState({scale: this.state.scale + delta});
  }
  /** @method render
    * Renders the emulated screen.
    */
  render() {
    return (
      <div>
        <div className="screen-tools">
          <span>
            Device
            <select onChange={this.handleSelect}>
              <optgroup label="Monitors">
                <option value="1024x768">1024x768</option>
                <option value="1280x768">1280x768</option>
                <option value="1280x1024">1280x1024</option>
                <option value="1680x1050">1680x1050</option>
                <option value="1920x1200">1920x1200</option>
                <option value="2048x1536">2048x1536</option>
                <option value="2560x1600">2560x1600</option>
                <option value="2560x2048">2560x2048</option>
              </optgroup>
              <optgroup label="Phones">
                <option value="320x568">iPhone 5</option>
                <option value="375x667">iPhone 6</option>
                <option value="414x746">iPhone 6 Plus</option>
                <option value="375x667">iPhone 7</option>
                <option value="414x736">iPhone 7 Plus</option>
                <option value="414x736">Galaxy Note 5</option>
                <option value="414x736">Galaxy S7</option>
                <option value="414x736">Galaxy S7 Edge</option>
                <option value="411x731">Nexus 6P</option>
                <option value="411x731">Nexus 5x</option>
                <option value="411x731">Pixel</option>
              </optgroup>
              <optgroup label="Tablets">
                <option value="1280x850">Chromebook Pixel</option>
                <option value="1024x1366">iPad Pro</option>
                <option value="768x1024">iPad Pro (3&4)</option>
                <option value="768x1024">iPad Mini/Air</option>
                <option value="800x1280">Galaxy Tab 10</option>
                <option value="600x960">Nexus 7</option>
                <option value="768x1024">Nexus 9</option>
              </optgroup>
              <optgroup label="Televisions">
                <option value="720x780">Standard</option>
                <option value="1280x720">HD 720</option>
                <option value="1920x1080">HD 1080</option>
              </optgroup>
            </select>
          </span>
          <span>
            Screen Size
            <input type="text"
              name="width"
              value={this.state.width}
              onChange={this.handleChange}
              />
            x
            <input type="text"
              name="height"
              value={this.state.height}
              onChange={this.handleChange}
              />
          </span>
          <span>
            <FontAwesome name="mobile"
              size="2x"
              onClick={()=>this.handleRotate()}
              rotate={(this.state.rotate)?270:null}
              />
          </span>
          <span>
            <FontAwesome name="search-plus"
              onClick={()=>this.handleZoom(0.1)}
              />
            <FontAwesome name="search-minus"
              onClick={()=>this.handleZoom(-0.1)}
              />
          </span>
        </div>
        <div className="screen-content">
          <iframe
            title="preview"
            style={{transform: `scale(${this.state.scale})`}}
            width={(this.state.rotate) ? this.state.height : this.state.width}
            height={(this.state.rotate) ? this.state.width : this.state.height}
            src={this.props.src}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screen-emulator/screen-emulator.js